module.exports = __webpack_public_path__ + "img/safe-3.b07ee99d.png";